import * as yup from "yup";
export * from './person'
export * from './address'
export * from './vehicle'
export * from './baseParams'
export * from './generalParams'
export * from './travel/TravelAddonValidationSchema'
export * from './travel/TravelValidationSchema'
export * from './property/PropertyValidationSchema'
export * from './property/PropertyDataValidationSchema'
export * from './property/PropertyHouseholdValidationSchema'
export * from './property/PropertyRealtyValidationSchema'
export * from './property/PropertyAddressValidationSchema'

export function customNullable<T extends yup.BaseSchema>(arg: T): T {
    return arg
        .transform((value: any) => (isNaN(value) ? undefined : value))
        .nullable();
}